export const changeTheViewContextMenuOption = "F9uI5c";
export const densitySectionLabel = "hiupld";
export const messageHeightSectionLabel = "XIlakc";
export const multipleRowsLabel = "$HPmL";
export const autoSwitchRowStyleLabel = "q$sGje";
export default {changeTheViewContextMenuOption,densitySectionLabel,messageHeightSectionLabel,multipleRowsLabel,autoSwitchRowStyleLabel};